import axios from 'axios';
import { Utm } from '../api/types';

const EVENT_GROUP = 'external_sales';

export type FunnelEvent =
  | { event: 'Landing_View'; data: { campaignCode: string; utm: Utm } }
  | { event: 'Buy_Click'; data: { campaignCode: string; sku: string; utm: Utm } };

// Best-effort guarded GET to the analytics sink: no-ops when the URL is unset, so a
// funnel-event failure can never break the funnel it measures.
export function emitFunnelEvent({ event, data }: FunnelEvent): void {
  const url = process.env.REACT_APP_ANALYTICS_URL;
  if (!url) {
    return;
  }
  axios
    .get(`${url}event`, {
      params: { event, data: { ...data, event_group: EVENT_GROUP, sent_at: Date.now() } },
    })
    .catch(() => undefined);
}
